import styled from 'styled-components'

type Props = {
	align: 'left' | 'right' | 'center'
}

export const AlignmentWrapper = styled.div<Props>`
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	column-gap: 8px;
	text-align: ${({ align }) => align};
	height: 100%;

	> svg {
		height: fit-content;
	}
`
